import React from 'react';
import {css} from '@emotion/react';

import TextField, {TextFieldProps} from '@src/components/atoms/TextField';
import PasswordRules from '@src/components/molecules/PasswordRules';
import {useBoolean} from '@src/hooks/useBoolean';

export interface PasswordWithRulesCardProps extends Pick<TextFieldProps, 'error' | 'isValid' | 'onChange' | 'onBlur'> {
  isShowingPasswordRules?: boolean;
  password: string;
  label?: string;
}

const PasswordWithRulesCard = ({
  label = 'Password',
  password,
  error,
  isValid,
  onChange,
  onBlur,
}: PasswordWithRulesCardProps) => {
  const [isShowingPasswordRules, setIsShowingPasswordRules] = useBoolean();
  return (
    <div
      css={css`
        position: relative;
      `}>
      <TextField
        label={label}
        name="password"
        type="password"
        error={error}
        isValid={isValid}
        onChange={onChange}
        onFocus={setIsShowingPasswordRules.setTrue}
        onBlur={e => {
          onBlur?.(e);
          setIsShowingPasswordRules.setFalse();
        }}
        required
      />
      {isShowingPasswordRules && (
        <PasswordRules
          isBoxShadow
          password={password}
          css={css`
            position: absolute;
            left: calc(100% + 20px);
            /* Label Height */
            top: 23px;
          `}
        />
      )}
    </div>
  );
};

export default React.memo(PasswordWithRulesCard);
